import { getDeviations } from './elementShape';
import { MC_DISTRIBUTIONS } from './monteCarlo';
import { wirksamerCpk } from './cpk';

// Anteil jedes Maßes am Schließmaß, eine Quelle für Beitragsleiste, PDF
// und CSV.
//   worstcase  → linear nach Toleranzbreite
//   rss        → nach Breite² (RSS rechnet jedes Maß als normalverteilt)
//   montecarlo → nach Varianz der gewählten Verteilung, passend zum
//                Sampler in monteCarlo.js (Normal mit σ = T/(6·Cpk),
//                Dreieck mit Spitze am Nennmaß, ins Feld geklemmt)

// Abmaße relativ zum Nennmaß, das Nennmaß ist also der Nullpunkt.
export function massVarianz(el) {
  const { lower, upper } = getDeviations(el);
  const a = Math.min(lower, upper);
  const b = Math.max(lower, upper);
  const t = b - a;
  switch (el.distribution) {
    case MC_DISTRIBUTIONS.UNIFORM:
      return (t * t) / 12;
    case MC_DISTRIBUTIONS.TRIANGULAR: {
      const c = Math.min(Math.max(0, a), b);
      return (a * a + b * b + c * c - a * b - a * c - b * c) / 18;
    }
    default:
      return (t / (6 * wirksamerCpk(el))) ** 2;
  }
}

function gewicht(el, mode) {
  const { lower, upper } = getDeviations(el);
  const t = Math.abs(upper - lower);
  if (mode === 'worstcase') return t;
  if (mode === 'montecarlo') return massVarianz(el);
  return t * t;
}

// Prozent je Maß, null für inaktive (C5). Summe über aktive = 100, oder
// alles 0, wenn kein Maß eine Toleranz hat.
export function beitragsAnteile(elements, mode) {
  const g = elements.map((el) => (el.inactive ? null : gewicht(el, mode)));
  const summe = g.reduce((s, x) => s + (x ?? 0), 0);
  return g.map((x) => (x === null ? null : summe > 0 ? (x / summe) * 100 : 0));
}

export function beitragsLabel(mode) {
  if (mode === 'worstcase') return 'linear (WC)';
  if (mode === 'montecarlo') return 'Varianz je Verteilung (MC)';
  return 'quadratisch (RSS)';
}
